/**
 * Handles validation results from API responses
 * @param {Object} response - The API response object
 * @param {Function} showMessage - Function to show messages (either dispatch(showMessage()) or showMessage() directly)
 * @returns {boolean} - Returns true if validation was successful, false otherwise
 */
export const handleValidationResult = (response, showMessage) => {
  const validationResult = response?.payload?.validationResult;

  if (!validationResult) {
    // No validation result means success (for backward compatibility)
    return true;
  }

  if (!validationResult.success) {
    showMessage({
      title: `${validationResult.title || "Validation Error"}`,
      variant: "warning",
      autoHideDuration: null,
      message: `${validationResult.errorMessage || "An error occurred"}`,
    });
    return false;
  }

  return true;
};
